var map = {
	"./Hasan.png": 2060,
	"./address_image.svg": 1984,
	"./aws.png": 580,
	"./bc.png": 5492,
	"./blogs_image.svg": 9449,
	"./cloud_infrastructure.svg": 7068,
	"./coursera_logo.png": 9756,
	"./data_science.svg": 9140,
	"./developerActivity.svg": 6052,
	"./dsc_logo.png": 9216,
	"./education.svg": 4972,
	"./experience.svg": 9148,
	"./feelingProud.svg": 8404,
	"./freecopy_logo.png": 9896,
	"./fullstack.svg": 3300,
	"./github_logo.png": 3956,
	"./googleAssistant.jpg": 8388,
	"./googleAssistant.svg": 7464,
	"./google_logo.png": 6976,
	"./ibm_logo.png": 4904,
	"./inex.png": 152,
	"./integrify.png": 3384,
	"./intel_logo.jpg": 5808,
	"./jsFramework.svg": 9716,
	"./legato_logo.png": 8280,
	"./lws.png": 9680,
	"./manOnTable.svg": 1040,
	"./programmer.svg": 2504,
	"./projects_image.svg": 6148,
	"./quanturi.png": 2098,
	"./savonia.png": 6720,
	"./talksCardBack.svg": 1084,
	"./talksCardBackAlt.svg": 480,
	"./tiktok_logo.png": 7788,
	"./udemy.png": 8652,
	"./ui_ux_design.svg": 4572,
	"./university-of-helsinki-logo.png": 6964
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3832;